import React, {useCallback, useEffect, useMemo, useState} from "react";
import Breadcrumbs from "../../../ui/Breadcrumbs";
import useRooms from "./useRooms";
import useQuery from "../../../ui/QueryTable/useQuery";
import {makeStyles} from "@material-ui/core/styles";
import DeleteConfirmationModal from "../../../ui/DeleteConfirmationModal";
import AddRoomModal from "../../components/AddRoomModal";
import QueryTable from "../../../ui/QueryTable";
import AddButton from "../../../ui/AddButton";
import RoomInfoDrawer from "../../components/RoomInfoDrawer";

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "/work/app/manage/resources"
  },
  {
    label: "Материально-технические ресурсы",
    link: "/work/app/manage/resources/mattech"
  },
  {
    label: "Мои помещения и площадки",
    link: "#"
  }
];

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "calc(100vh - 200px)"
    }
  },
});

const RoomsList = () => {
  const query = useQuery(17);
  const [focusedRoom, setFocusedRoom] = useState(-1);
  const [selection, setSelection] = useState([]);
  const [addRoomOpen, setAddRoomOpen] = useState(false);
  const [deleteRoomOpen, setDeleteRoomOpen] = useState(false);
  const {root} = useStyles();

  const {
    roomsData,
    deleteRooms,
    createRoom,
    isDeletingRooms,
    isCreatingRoom
  } = useRooms();

  const actionsDisabled = isCreatingRoom || isDeletingRooms;

  const createRoomChain = useCallback((form) => {
    return createRoom(form)
      .then(() => {
        setAddRoomOpen(false);
        query.refresh();
      }, () => {
        setAddRoomOpen(false);
        query.refresh();
      })
  }, [setAddRoomOpen, createRoom, query]);

  const deleteRoomsChain = useCallback(() => {
    return deleteRooms(selection)
      .then(() => {
        setDeleteRoomOpen(false);
        query.refresh();
      }, () => {
        setDeleteRoomOpen(false);
        query.refresh();
      })
  }, [setDeleteRoomOpen, deleteRooms, selection, query]);

  const TableRowClick = useCallback((e) => {
    const focusedFacility = e ? e.key : -1;
    setFocusedRoom(focusedFacility);
  }, [setFocusedRoom]);

  const TableSelectionChanged = useCallback(e => {
    setSelection(e.selectedRowKeys || []);
  }, [setSelection]);

  const showDeleteModal = useCallback(() => {
    setDeleteRoomOpen(!deleteRoomOpen);
  }, [deleteRoomOpen]);

  const showAddModal = useCallback(() => {
    setAddRoomOpen(!addRoomOpen)
  }, [addRoomOpen]);

  const secondaryActions = useMemo(() => {
    return [
      {
        label: "Удалить выбранные",
        onClick: showDeleteModal,
        disabled: actionsDisabled || (!selection || selection.length === 0)
      },
    ]
  }, [showDeleteModal, selection]);

  useEffect(() => {
    query.load();
  }, []);

  return (
    <div>
      <DeleteConfirmationModal
        modalText="Удалить выбранные адреса?"
        open={deleteRoomOpen}
        onConfirm={deleteRoomsChain}
        handleClose={showDeleteModal}
      />
      <AddRoomModal
        open={addRoomOpen}
        handleClose={showAddModal}
        createRoom={createRoomChain}
        isCreatingRoom={isCreatingRoom}
        createdRoom={roomsData.createdRoom}
      />
      <Breadcrumbs items={items} />
      <div className={root}>
        <QueryTable
          focusedId={focusedRoom}
          onSelectionChanged={TableSelectionChanged}
          onRowClick={TableRowClick}
          primaryActions={<AddButton onClick={showAddModal}/>}
          secondaryActions={secondaryActions}
          {...query} />
        <RoomInfoDrawer
          handleDrawerClose={() => setFocusedRoom(-1)}
          roomId={focusedRoom}
          open={focusedRoom !== -1}
        />
      </div>
    </div>
  );
};

export default RoomsList;
